
export default {
  props: {
    wareInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    }
  }
}
